/**
 * Generates and triggers a CSV file download in the browser.
 *
 * @param {Object} options
 * @param {string[]} options.headers - Column headers
 * @param {Array<Array<string|number>>} options.rows - Row data as arrays
 * @param {string} [options.filename='download.csv'] - Output filename
 */
export function downloadCsv({ headers, rows, filename = 'download.csv' }) {
  const escape = (value) => {
    const str = String(value ?? '')
    return str.includes(',') || str.includes('"') || str.includes('\n')
      ? `"${str.replace(/"/g, '""')}"`
      : str
  }

  const csv = [headers, ...rows]
    .map((row) => row.map(escape).join(','))
    .join('\n')

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}